<div class="main-header">
	<h5>
		{{
			'CANDIDATES_PAGE.EDIT_CANDIDATE.INTERVIEW.SCHEDULED_INTERVIEWS'
				| translate
		}}
	</h5>
	<div class="buttons">
		<ga-employee-multi-select
			class="multi-select"
			[allEmployees]="employees"
			[label]="false"
			(selectedChange)="onEmployeeSelected($event)"
		>
		</ga-employee-multi-select>
		<ga-candidate-multi-select
			class="multi-select ml-4"
			[allCandidates]="candidates"
			(selectedChange)="onCandidateSelected($event)"
		>
		</ga-candidate-multi-select>
	</div>
</div>
<nb-card-body>
	<full-calendar
		*ngIf="calendarOptions"
		#calendar
		[options]="calendarOptions"
	></full-calendar>
</nb-card-body>
